export const selectIssues = state => state.tickets.issues
